export default "__VITE_ASSET__c1a42e1d__"